import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from './en';
import zhLocale from './zh';
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementzhLocale from 'element-ui/lib/locale/lang/zh-CN';
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.getItem("languageSet") || "cn",// set locale，默认中文
  messages:{
    en:{
      ...enLocale,
      ...elementEnLocale
    },
    cn:{
      ...zhLocale,
      ...elementzhLocale
    },
  }
})
export default i18n;